// extracted by mini-css-extract-plugin
export default {"container":"AdminCommunications_container__BjgGG"};